import { Row, Col } from 'react-bootstrap';
import React from "react";
import config from "../etc/config.json";


function Weather(props) {

  return <Row className="py-0 mt-3">
    <Col className="py-0 pr-0 pt-0 pb-0">
    {(() => {
                if ((props.precipitation === "Light"))
                  return <img alt="n/a" src={config.DIR_ICONS + "regen.gif"} height="32" />
                if ((props.precipitation === "Heavy"))
                  return <img alt="n/a" src={config.DIR_ICONS + "starkerregen.gif"} height="32" />
                if ((props.precipitation === "None" && props.cloudCover === "Cloudy"))
                  return <img alt="n/a" src={config.DIR_ICONS + "wolke.gif"} height="32" />
                if ((props.precipitation === "None" && props.cloudCover === "PartlyCloudy"))
                  return <img alt="n/a" src={config.DIR_ICONS + "sonnewolke.gif"} height="32" />
                else
                  return <img alt="n/a" src={config.DIR_ICONS + "sonne.gif"} height="32" />
              })()}
    {(() => {
                if ((props.precipitation === "Light"))
                  return <span className="ml-1">{props.precipitation} Rain</span>
                if ((props.precipitation === "Heavy"))
                  return <span className="ml-1">{props.precipitation} Rain</span>
                else
                  return <span className="ml-1">{props.cloudCover}</span>
              })()}
    </Col>
    <Col className="py-0 pr-0 pt-0 pb-0">
      <img alt="n/a" src={config.DIR_ICONS + "thermometer.gif"} height="32" />
      <span className="ml-1">{props.temperature} °C</span>
    </Col>
    <Col className="py-0 pr-0 pt-0 pb-0">
      <img alt="n/a" src={config.DIR_ICONS + "wind.gif"} height="32" />
      <span className="ml-1"><br />{props.windDirection}: {props.windForce} Bft</span>
    </Col>
    <Col className="py-0 pr-0 pt-0 pb-0">
      <img alt="n/a" src={config.DIR_ICONS + "hoehe.gif"} height="32" />
      <span className="ml-1">{props.altitude}m</span>
    </Col>
  </Row>;
}

export default Weather;